<template>
  <v-btn
    icon
    class="close-btn"
    @click="clickBtn"
  >
    <font-awesome-icon
      :icon="['fas', 'times']"
      size="2x"
    />
  </v-btn>
</template>

<script>
export default {
  name: 'Overlay',
  methods: {
    clickBtn() {
      this.$emit('clickBtn');
    },
  },
};
</script>

<style>
.close-btn {
  position: absolute;
  background-color: #434a5a;
  border-radius: 5px;
  top: 46px;
  right: 48px;
}
</style>
